import { Pipe, PipeTransform } from '@angular/core';
import { enumBookingStatus } from '../utils/enum-booking-status';

@Pipe({ name: 'bookingStatusLabel' })
export class BookingStatusLabelPipe implements PipeTransform {
  transform(id: number, ...args: boolean[]): string {
    switch (id) {
      case enumBookingStatus.PAYMENT_PROCESSING:
        return 'In corso';
      case enumBookingStatus.PAYED:
        return 'Pagato';
      case enumBookingStatus.ADVANCE_PAYED:
        return 'Pagato';
      case enumBookingStatus.CANCELED:
        return 'Cancellato';
      case enumBookingStatus.REFUNDED:
        return 'Rimborsato';
      case enumBookingStatus.SUSPENDED:
        return 'sospeso';
    }
    return ``;
  }
}
